import { Menu, MenuItem } from '@mui/material';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from '../../../../../reduxService/hooks';
import { EProjectType } from '../../../../enum/project';
import { changeLanguage, loadLanguages } from '../../../../localization';
import { selectProjectInfo } from '../../../../store/projectInfo/projectInfoSlice';
import { ILanguageButtonProps } from './ILanguageButton';
import { getLanguages } from '../../../../api/products/BeMaccaferriProductsHelper';
import { ILanguage, ILanguagesResponse } from '../../../../api/IApiResponse';

const LanguageButton = (props: ILanguageButtonProps) => {
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const [languages, setLanguages] = React.useState<ILanguage[]>([]);
    const projectInfo = useAppSelector(selectProjectInfo);

    const { t } = useTranslation();
    const open = Boolean(anchorEl);
    const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(e.currentTarget);
    };
    const handleClose = (language: string) => {
        changeLanguage(language);
        setAnchorEl(null);
    };

    /*React.useEffect(() => {
        if (projectInfo.data && projectInfo.data.projectType !== undefined && projectInfo.data.projectType !== EProjectType.Macro1) {
            changeLanguage(ELanguages.en);
        }
    }, [projectInfo]);*/

    React.useEffect(() => {
        const getLans = async () => {
            const resp: ILanguagesResponse = (await getLanguages()).data;
            await loadLanguages(resp.value.languages);
            setLanguages(resp.value.languages);
        }
        getLans();
    }, []);

    return (
        <>
            <button type='button' className={props.className} onClick={handleClick}>
                <i className='fa-solid fa-language' />
                {t('header_language_button')}
                <i className='fa-solid fa-angle-down' />
            </button>

            <Menu
                id='basic-menu-language'
                anchorEl={anchorEl}
                open={open}
                onClose={() => setAnchorEl(null)}
                MenuListProps={{
                    'aria-labelledby': 'basic-button',
                }}>
                {languages.map((language, i) => (
                    <MenuItem className={props.className} onClick={() => handleClose(language.languageCode)} key={`language_MenuItem_${language.languageCode}`}>
                        {language.description}
                    </MenuItem>
                ))}
            </Menu>
        </>
    );
};

export default LanguageButton;
